export const SELECT_CONTACT = 'contactsTake/SELECT_CONTACT';
export const RESET = 'contactsTake/RESET';
